module.exports = __webpack_public_path__ + "img/userC06.454a171a.jpg";